import { useEffect, useState } from "react";

const Preloader = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 1000);
  }, []);

  return (
    <>
      {active ? (
        <div className="preloader ">
          <img src="assets/images/logo/blinkBuyBlackLog.png" alt="" style={{ width: '280px', height: 'auto' }} />
        </div>

      ) : (<div></div>)}
    </>
  );
};

export default Preloader;
